import styled, { css, keyframes } from "styled-components";
import { viewSizeCalculator } from "../../utils";

const fadeIn = (value) => keyframes`
  from {
    opacity: 0;
    transform: translateY(${value});
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const TableWrapper = styled.div`
  overflow-x: auto;
  position: relative;
  //max-height: 500px;
  margin-top: ${() => `${viewSizeCalculator(0.5)}`}; // just to adjust

  /* Custom scrollbar styling */
  &::-webkit-scrollbar {
    width: 4px; // Width of the vertical scrollbar
    //height: 4px; // Height of the horizontal scrollbar
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1; // Light gray background for the scrollbar track
    border-radius: 4px; // Rounded corners for the track
  }

  &::-webkit-scrollbar-thumb {
    background: #3333334d; // Light gray color for the scrollbar thumb
    border-radius: 4px; // Rounded corners for the thumb
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #33333380; // Darker gray color when hovering over the scrollbar thumb
  }
  transition: all 0.3s ease-in-out;

  ${({ animate }) =>
    animate &&
    css`
      animation: ${fadeIn(viewSizeCalculator(1))} 0.4s ease-in-out forwards;
    `}
`;

export const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  text-align: left;
  transition: all 0.3s ease-in-out;
  // transform: ${({ isVisible }) => (!isVisible ? "translateX(-12px)" : "translateX(0px)")};
  transform: ${({ isVisible }) =>
    `translateX(${isVisible ? "0px" : `-${viewSizeCalculator(0.95)}`})`};
`;

export const TableHeader = styled.thead`
  height: ${() => `${viewSizeCalculator(1.375)}`}; // 1.375rem;
  position: sticky; // Make the header sticky
  top: 0; // Stick to the top of the container
  background-color: white; // Ensure the header has a background color
  z-index: 1; // Ensure the header stays above the body
  transition: all 0.3s ease-in-out;
`;

export const TableRow = styled.tr`
  height: ${() => `${viewSizeCalculator(2.75)}`};

  &:hover {
    background-color: #F6F6F6;
  }
  transition: all 0.3s ease-in-out;
`;

export const TableHeaderCell = styled.th`
  height: ${() => `${viewSizeCalculator(0.875)}`}; // 0.875rem;
  padding-right: ${() => `${viewSizeCalculator(0.5)}`}; //  0.5rem;
  padding-bottom: ${() => `${viewSizeCalculator(0.5)}`}; //  0.5rem;
  font-size: ${() => `${viewSizeCalculator(0.8125)}`}; //  0.8125rem;
  font-weight: 600;
  line-height: ${() => `${viewSizeCalculator(0.8738)}`}; //  0.8738rem;
  white-space: nowrap;
  // color: #333333;
  // opacity: 30%;
  transition: all 0.3s ease-in-out;
  &:nth-child(1) {
    padding-right: 0;
    padding-left: ${() => `${viewSizeCalculator(0.2)}`}; //  0.5rem;
  }

  &:nth-last-child(2) {
    // padding-right: ${() => `${viewSizeCalculator(1)}`}; // increase as needed
    padding-left: ${() => `${viewSizeCalculator(1)}`}; // increase as needed
  }

  &:nth-last-child(1) {
    // padding-right: ${() => `${viewSizeCalculator(1)}`}; // increase as needed
    padding-left: ${() => `${viewSizeCalculator(1)}`}; // increase as needed
  }
`;

export const TableHeaderCellAnimated = styled.th`
  transition: all 0.3s ease-in-out;
  width: ${({ isVisible }) => isVisible ? viewSizeCalculator(2.5) : "0px"};
  padding-left: ${({ isVisible }) => isVisible ? viewSizeCalculator(0.7) : "0px"};
  padding-bottom: ${() => `${viewSizeCalculator(0.5)}`}; //  0.5rem;
  border: none;
  overflow: hidden;
  white-space: nowrap;
`;

export const TableCell = styled.td`
  border-bottom: ${() =>
    `${viewSizeCalculator(
      0.0625,
    )} solid #3333331a`}; //  0.0625rem solid #3333331a;
  padding-right: ${() => `${viewSizeCalculator(0.5)}`}; //  0.5rem;
  font-size: ${() => `${viewSizeCalculator(0.8125)}`}; //  0.8125rem;
  font-weight: 500;
  line-height: ${() => `${viewSizeCalculator(0.9831)}`}; //  0.9831rem;
  /* text-align: ${({isRightAligned}) => isRightAligned ? 'right' : 'left'}; */
  color: #333333;

  cursor: ${({ isCursorPointer }) => isCursorPointer && "pointer"};

  &:hover {
     color:${({ isCursorPointer }) => isCursorPointer ? "#E35B42" : "inherit"};
  }

  ${({ isHospitalName }) =>
    isHospitalName &&
    `
      max-width: ${viewSizeCalculator(16.25)};  // Adjust width as needed
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      // display: block;
  `}
  transition: all 0.3s ease-in-out;

  &:empty {
    pointer-events: none;
    cursor: default;
  }
  &:nth-child(1) {
    text-align: center;
    padding-left: ${() => `${viewSizeCalculator(0.2)}`}; //  0.5rem;
  }

  &:nth-last-child(2) {
    // padding-right: ${() => `${viewSizeCalculator(1)}`}; // increase as needed
    padding-left: ${() => `${viewSizeCalculator(1)}`}; // increase as needed
  }

  &:nth-last-child(1) {
    // padding-right: ${() => `${viewSizeCalculator(1)}`}; // increase as needed
    padding-left: ${() => `${viewSizeCalculator(1)}`}; // increase as needed
  }
  &:nth-last-child(3) {
    border-top-left-radius: ${({ isFirst }) => isFirst ? `${viewSizeCalculator(0.25)}` : "0px"};
    border-top-right-radius: ${({ isFirst }) => isFirst ? `${viewSizeCalculator(0.25)}` : "0px"};
  }
`;

export const TableCellAnimated = styled.td`
  border-bottom: ${() =>
    `${viewSizeCalculator(
      0.0625,
    )} solid #3333331a`};
  transition: all 0.3s ease-in-out;
  width: ${({ isVisible }) => isVisible ? viewSizeCalculator(2.5) : "0px"};
  padding-left: ${({ isVisible }) => isVisible ? viewSizeCalculator(0.7) : "0px"};
  overflow: hidden;
  white-space: nowrap;
`;

export const IconWrapper = styled.div`
  cursor: pointer;
  svg {
    width: ${() => `${viewSizeCalculator(1.5)}`}; // 2.5rem;
    height: ${() => `${viewSizeCalculator(1.5)}`}; // 2.5rem;
  }
`;

export const FactSheetIconWrapper = styled.div`
  cursor: pointer;
  svg {
    width: ${() => `${viewSizeCalculator(1.4)}`}; // 2.5rem;
    height: ${() => `${viewSizeCalculator(1.4)}`}; // 2.5rem;
  }
`;

export const LoadMoreContainer = styled.div`
  width: 100%;
  height: ${() => `${viewSizeCalculator(3.75)}`}; // 3.75rem;
`;

export const SortIconWrapper = styled.div`
  transition: transform 0.3s ease-in-out;
  cursor: pointer;
  transform: ${({ sortOrder }) =>
    sortOrder === "desc" ? "rotate(180deg)" : "none"};
  svg {
    width: ${() => `${viewSizeCalculator(1.5)}`}; // 2.5rem;
    height: ${() => `${viewSizeCalculator(1.5)}`}; // 2.5rem;
  }
`;

export const InfoIconWrapper = styled.div`
  transition: transform 0.3s ease-in-out;
  cursor: pointer;
  transform: ${({ sortOrder }) =>
    sortOrder === "desc" ? "rotate(180deg)" : "none"};
  svg {
    width: ${() => `${viewSizeCalculator(1)}`}; // 2.5rem;
    height: ${() => `${viewSizeCalculator(1)}`}; // 2.5rem;
  }
`;

const slideIn = keyframes`
  0% {
    transform: translateX(-20px);
    opacity: 0;
  }
  100% {
    transform: translateX(0px);
    opacity: 1;
  }
`;

const slideOut = keyframes`
  0% {
    transform: translateX(0px);
    opacity: 1;
  }
  100% {
    transform: translateX(-20px);
    opacity: 0;
  }
`;

export const CheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
  transition: all 0.3s ease-in-out;

  ${({ isVisible }) =>
    isVisible
      ? css`
          animation: ${slideIn} 0.3s ease-in-out forwards;
        `
      : css`
          animation: ${slideOut} 0.3s ease-in-out forwards;
        `}
`;

export const Checkbox = styled.input.attrs(props => ({
  type: 'checkbox',
  disabled: props.isSelectAllDisabled,
}))`
  appearance: none;
  -webkit-appearance: none;
  width: ${() => `${viewSizeCalculator(1.063)}`}; // 2.5rem;
  height: ${() => `${viewSizeCalculator(1.063)}`}; // 2.5rem;
  cursor: pointer;
  border-radius: ${() => `${viewSizeCalculator(0.188)}`};
  border: 1px solid #333333;
  opacity: 25%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: white;

  &:checked {
    background-color: #f96c50;
    border-color: #f96c50;
    opacity: 100%;
  }

  &:checked::after {
    content: '';
    width: ${() => `${viewSizeCalculator(0.188)}`};
    height: ${() => `${viewSizeCalculator(0.438)}`};
    border: solid white;
    // border-width: 0 2px 2px 0;
    border-width: ${() => `0 ${viewSizeCalculator(0.125)} ${viewSizeCalculator(0.125)} 0`};
    transform: rotate(45deg);
    // margin-top: -2px;
    margin-top: ${() => `-${viewSizeCalculator(0.125)}`};
  }
  &:disabled {
    cursor: not-allowed;
  }
`;

export const CompareAllIconContainer = styled.div`
  cursor: pointer;
  margin-left: ${() => `${viewSizeCalculator(0.125)}`};
  svg {
    width: ${() => `${viewSizeCalculator(1.5)}`}; // 2.5rem;
    height: ${() => `${viewSizeCalculator(1.5)}`}; // 2.5rem;
  }
`;

export const HospitalNameWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${() => `${viewSizeCalculator(0.4)}`};
  min-width: 0;
`;

export const PartnerLocationIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: ${() => `${viewSizeCalculator(1)}`};
  height: ${() => `${viewSizeCalculator(1)}`};
  min-width: ${() => `${viewSizeCalculator(1)}`};
  min-height: ${() => `${viewSizeCalculator(1)}`};
  overflow: visible;

  svg {
    width: 100%;
    height: 100%;
    display: block;
    overflow: visible;
    flex-shrink: 0;
  }
`;

export const ColumnHeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  white-space: nowrap;
  gap: ${() => `${viewSizeCalculator(0.5)}`}; // 0.5rem;  
  justify-content: ${({ isFirst }) => isFirst ? "center" : "flex-start"};
`;

export const RankingCell = styled.span`
  display: inline-block;
  padding: ${() => `${viewSizeCalculator(0.25)} ${viewSizeCalculator(0.5)}`};
  border-radius: ${() => `${viewSizeCalculator(0.25)}`};
  min-width: ${() => `${viewSizeCalculator(2)}`};
  text-align: center;
  font-weight: 600;
`;

export const ColorScaleLegend = styled.div`
  // margin-top: ${() => `${viewSizeCalculator(1)}`};
  padding: ${() => `${viewSizeCalculator(0.5)}`};
  background-color: #f8f9fa;
  border-radius: ${() => `${viewSizeCalculator(0.25)}`};
  font-size: ${() => `${viewSizeCalculator(0.75)}`};
  color: #666666;
  border: 1px solid #e9ecef;
`;

export const ColorGradient = styled.div`
  flex: 1;
  height: ${() => `${viewSizeCalculator(0.5)}`};
  background: linear-gradient(to right, #c34141, #c96d65, #d9a07c, #c8bf8d, #a7c286, #85b97b, #68ab72, #4e9e6a);
  border-radius: ${() => `${viewSizeCalculator(0.125)}`};
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.1);
`;

export const LegendLabel = styled.span`
  background-color: ${props => props.color};
  color: white;
  padding: ${() => `${viewSizeCalculator(0.125)} ${viewSizeCalculator(0.25)}`};
  border-radius: ${() => `${viewSizeCalculator(0.125)}`};
  font-size: ${() => `${viewSizeCalculator(0.625)}`};
  font-weight: 600;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
`;

export const NoDataFoundContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  flex: 1;

  svg {
    width: ${() => `${viewSizeCalculator(480, true)}`};
    height: auto;
  }
`;

export const NoDataFoundText = styled.p`
  font-family: Inter;
  font-size: ${() => `${viewSizeCalculator(18, true)}`};
  line-height: ${() => `${viewSizeCalculator(1.375)}`};
  font-weight: 600;
  color: #333333;
  text-align: center;
`;